// src/components/scratch/PrizeTierTable.jsx
import React from "react";
import AdminTable from "../pages/admin-dash/AdminTable";
import Badge from "../ui/Badge";
import { formatMoney, formatCount } from "../../services/scratchService";

/**
 * Prize-tier breakdown for a single game. Reuses the app's AdminTable so
 * sorting/paging/theming match the rest of the product. Pure public counts —
 * remaining, printed, claimed, and the claimed %.
 *
 * @param {{ tiers: import("../../services/scratchService").ScratchPrizeTierDto[], loading?: boolean }} props
 */
export default function PrizeTierTable({ tiers = [], loading = false }) {
  const columns = [
    {
      key: "prizeAmount",
      label: "Prize",
      sort: true,
      value: (t) => Number(t.prizeAmount) || 0,
      render: (t) => (
        <span className="inline-flex items-center gap-2">
          <span className="font-medium tabular-nums" style={{ color: "var(--txt)" }}>
            {formatMoney(t.prizeAmount)}
          </span>
          {t.topPrize && <Badge variant="gold">Top</Badge>}
        </span>
      ),
    },
    {
      key: "prizesRemaining",
      label: "Remaining",
      sort: true,
      align: "right",
      value: (t) => Number(t.prizesRemaining) || 0,
      render: (t) => (
        <span
          className="tabular-nums font-medium"
          style={{ color: Number(t.prizesRemaining) > 0 ? "var(--teal)" : "var(--red)" }}
        >
          {formatCount(t.prizesRemaining)}
        </span>
      ),
    },
    {
      key: "prizesPrinted",
      label: "At start",
      sort: true,
      align: "right",
      value: (t) => Number(t.prizesPrinted) || 0,
      render: (t) => (
        <span className="tabular-nums" style={{ color: "var(--txt-2)" }}>
          {t.prizesPrinted != null ? formatCount(t.prizesPrinted) : "—"}
        </span>
      ),
    },
    {
      key: "claimedPct",
      label: "Claimed",
      sort: true,
      align: "right",
      value: (t) => (t.claimedPct == null ? -1 : Number(t.claimedPct)),
      render: (t) =>
        t.claimedPct == null ? (
          <span style={{ color: "var(--txt-3)" }}>—</span>
        ) : (
          <span className="tabular-nums" style={{ color: "var(--txt-2)" }}>
            {Math.round(t.claimedPct)}%
          </span>
        ),
    },
  ];

  return (
    <AdminTable
      columns={columns}
      rows={tiers}
      loading={loading}
      rowKey="prizeAmount"
      emptyMessage="No prize-tier data for this game."
      emptyIcon="ticket-off"
      defaultPageSize={25}
      defaultSort={{ key: "prizeAmount", dir: "desc" }}
    />
  );
}
